import { request } from 'src/api/request';

export const deleteCRMIntegration = async ({ id }: { id: number }) => {
  return await request({
    url: `v1/integrations/crm-links/${id}/`,
    method: 'DELETE',
  });
};
